import React from 'react';
import styles from './Button.module.scss';
import { classNames } from '../../utils/helpers';
import LoadingSpinner from '../LoadingSpinner';
import Icon from '../Icon';
export var ButtonSize;
(function (ButtonSize) {
    ButtonSize["Medium"] = "medium";
    ButtonSize["Small"] = "small";
})(ButtonSize || (ButtonSize = {}));
export var ButtonType;
(function (ButtonType) {
    ButtonType["Primary"] = "primary";
    ButtonType["Secondary"] = "secondary";
    ButtonType["CallToAction"] = "callToAction";
})(ButtonType || (ButtonType = {}));
export var ButtonLabelAlignment;
(function (ButtonLabelAlignment) {
    ButtonLabelAlignment["Top"] = "top";
    ButtonLabelAlignment["Right"] = "right";
    ButtonLabelAlignment["Bottom"] = "bottom";
    ButtonLabelAlignment["Left"] = "left";
})(ButtonLabelAlignment || (ButtonLabelAlignment = {}));
const Button = ({ id, name = id, label, labelAlignment = ButtonLabelAlignment.Left, iconVariant, iconSvg, size = ButtonSize.Medium, type = ButtonType.Primary, outline = false, disabled = false, form = false, fullWidth = false, loading = false, onClick = () => undefined, children, }) => (React.createElement("div", { className: classNames(styles.container, fullWidth && styles.fullWidth) },
    React.createElement("button", { id: id, name: name, type: form ? 'submit' : 'button', disabled: disabled || loading, onClick: onClick, className: classNames(styles[size], styles[`${type}${outline ? '-outline' : ''}`], styles[labelAlignment], (iconVariant || iconSvg) && styles.icon, loading && styles.loading) },
        !loading &&
            [ButtonLabelAlignment.Top, ButtonLabelAlignment.Left].includes(labelAlignment) && (React.createElement(React.Fragment, null,
            React.createElement("div", { className: styles.content },
                label,
                children),
            (iconVariant || iconSvg) && (React.createElement(Icon, { variant: iconVariant, svg: iconSvg })))),
        !loading &&
            [ButtonLabelAlignment.Bottom, ButtonLabelAlignment.Right].includes(labelAlignment) && (React.createElement(React.Fragment, null,
            (iconVariant || iconSvg) && (React.createElement(Icon, { variant: iconVariant, svg: iconSvg })),
            React.createElement("div", { className: styles.content },
                children,
                label))),
        !!loading && React.createElement(LoadingSpinner, null))));
export default Button;
